module.exports = __webpack_public_path__ + "img/ok.36199365.svg";